module.exports = __webpack_public_path__ + "static/media/avatar-1.05dd2498.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-1.png
// module id = 240
// module chunks = 0